// Utility helpers for working with QuestionnaireResponse payloads

/**

 * @returns {Array|null} questionResponse array or null if invalid
 */
export const buildQuestionResponseFromQR = (qr, overridesOrReason) => {
  if (!qr || !Array.isArray(qr.item)) return null;

  let newReason;
  let newTelephone;

  if (typeof overridesOrReason === "string") {
    newReason = overridesOrReason;
  } else if (overridesOrReason && typeof overridesOrReason === "object") {
    newReason = overridesOrReason.newReason;
    newTelephone = overridesOrReason.newTelephone;
  }

  return qr.item.map((item) => {
    const isTextType =
      item.questionType === "freeText" ||
      item.questionType === "singleFreeText" ||
      item.questionType === "dropDown";

    const answers = (item.answer || []).map((a, idx) => {
      const shouldOverrideReason =
        item.tag === "REASON" &&
        typeof newReason === "string" &&
        idx === 0;

      const shouldOverrideTelephone =
        item.tag === "TELEPHONE" &&
        typeof newTelephone === "string" &&
        idx === 0;

      let baseAnswer;

      if (shouldOverrideReason) {
        baseAnswer = newReason.trim();
      } else if (shouldOverrideTelephone) {
        baseAnswer = newTelephone.trim();
      } else if (isTextType) {
        baseAnswer = a.valueString || "";
      } else {
        baseAnswer = !!a.valueBoolean;
      }

      return {
        answer: baseAnswer,
        option: a.option || null,
        ratingText: a.ratingText || null,
      };
    });

    return {
      id: item.linkId,
      questionId: item.questionId || null,
      tag: item.tag,
      question: item.text,
      questionType: item.questionType,
      required: item.required,
      answer: answers,
    };
  });
};

const snapshotAnswer = (answer) => {
  if (!Array.isArray(answer)) return [];
  return answer.map(({ key, ...rest }) => rest);
};

export const semanticSnapshot = (questionResponse) => {
  if (!Array.isArray(questionResponse)) return "[]";
  const normalized = questionResponse.map(({ key, ...question }) => ({
    ...question,
    answer: snapshotAnswer(question.answer),
  }));
  return JSON.stringify(normalized);
};


